import { axiosBase } from "utils";

// 3min timeout - call-report API proxies FusionPBX which can be very slow with large CDR datasets
const CALL_REPORT_TIMEOUT = 180000;

export function getCallReportService (url) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: url,
    timeout: CALL_REPORT_TIMEOUT,
  });
}

export function getCallReportStatsService () {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: "/call-report/stats",
    timeout: CALL_REPORT_TIMEOUT,
  });
}

export function getCallRecordingService (uuid) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    params: {uuid},
    url: "/call-report/recording",
    timeout: 60000,
  });
}